import React from 'react';
import profilePic from './profile-pic.png';
import milkersAvatar from './milkers-avatar.jpg';
import { Link } from 'gatsby';
import './Bio.css';
import {Card, ListGroup, Accordion} from 'react-bootstrap';

class Bio extends React.Component {
  render() {
    return (
      <div className="bio">
        <div title="bio-block" className="avatar">
          <Link to={'/'}>
            <img src={milkersAvatar} alt={`gatsby-comic-template`} />
          </Link>
        </div>
        <h4>Mustafa Ilker Sarac</h4>
        <p className="bio-slogan">
          <span>Software Engineer @thundraio, </span><br/>
          <span>@BilkentUniv CS Alumni, </span><br/>
          <span>thinks and codes with components ⚛️</span>
        </p>
      </div>
    );
  }
}

export default Bio;
